import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Reusing the same CSS file for now

// Default image to use if no image is provided
const defaultImage = 'https://via.placeholder.com/400x300?text=Restaurant+Image';

function RestaurantItem({ image, title, description, price, index }) {
  // Use the provided image or fall back to the default image
  const imageUrl = image || defaultImage;

  return (
    <Link to={`/restaurant/${index}`} className="restaurant-item restaurant-item-link">
      <div className="restaurant-item-image">
        <img src={imageUrl} alt={title} />
      </div>
      <div className="restaurant-item-content">
        <h3 className="restaurant-item-title">{title}</h3>
        <p className="restaurant-item-description">{description}</p>
        <div className="restaurant-item-price-cart">
          <span className="restaurant-item-price">{price}</span>
        </div>
      </div>
    </Link>
  );
}

export default RestaurantItem;
